import {
  createResourceKeys,
  type ResourceKeyParams,
} from "@/lib/resource-context";

export const oauthProvidersKeys = createResourceKeys("oauthProviders");

type ConnectedAccountsListParams = ResourceKeyParams & {
  oauthProviderId?: string;
  userId?: string;
};

const baseConnectedAccountsKeys = createResourceKeys("connectedAccounts");

export const connectedAccountsKeys = {
  ...baseConnectedAccountsKeys,

  list: ({
    binding,
    oauthProviderId,
    userId,
    ...rest
  }: ConnectedAccountsListParams): readonly unknown[] =>
    [
      ...baseConnectedAccountsKeys.list({ ...rest, binding }),
      oauthProviderId ?? "all",
      userId ?? "me",
    ] as const,
};
